import React from 'react';
export interface Spec {
  label: string;
  value: string;
}
interface SpecListProps {
  specs: Spec[];
  ariaLabel: string;
}

/** Compact labeled values for published starting guidance. */
export function SpecList({
  specs,
  ariaLabel
}: SpecListProps) {
  return <dl aria-label={ariaLabel} className="grid gap-px border border-rule bg-rule sm:grid-cols-2 lg:grid-cols-4" data-id="element-576" data-mp="m6t4bwo1fcnw">
      {specs.map(spec => <div key={spec.label} className="bg-white p-5" data-id="element-577" data-mp="cdu6rpakcbs5">
          <dt className="font-mono text-[9.5px] tracking-label text-copper" data-id="element-578" data-mp="h53toi4q910c">
            {spec.label.toUpperCase()}
          </dt>
          <dd className="rp-tabular mt-2 font-mono text-[17px] leading-snug text-navy" data-id="element-579" data-mp="3f0bc28yxrg6">
            {spec.value}
          </dd>
        </div>)}
    </dl>;
}